import { pxToRem } from '@modernhealth/vital-components';
import styled from '@emotion/styled';
import { colors as dsColors } from '@modernhealth/vital-foundation';

import React from 'react';
import { font } from 'src/shared/styles/variables';

import { Benefit } from '../models/benefits';
import { BenefitCardTestId } from '../models/testsIds';

interface Props {
    benefit: Benefit;
    onClick: (Benefit) => void;
}

const Container = styled.div({
    width: '220px',
    paddingTop: '6px',
    paddingLeft: '20px',
    paddingRight: '20px',
    paddingBottom: '20px',
    margin: '8px',
});

const Title = styled.h1(
    {
        color: dsColors.gray85,
        lineHeight: '24px',
        marginBottom: 0,
        paddingTop: '8px',
    },
    font.heavy(font.size.mediumExtended),
);
const Provider = styled.h2(
    {
        color: dsColors.gray65,
        lineHeight: '20px',
        paddingTop: '4px',
    },
    font.roman(font.size.base),
);

interface LogoContainerProp {
    color: string | undefined;
}

const LogoContainer = styled.div<LogoContainerProp>(({ color }) => {
    return {
        width: '212px',
        backgroundColor: color,
        height: '220px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: pxToRem(6),
    };
});

export const BenefitCard: React.FC<Props> = ({ benefit, onClick }) => {
    const { title, providerName, imageUrl, color, id } = benefit;
    return (
        <Container
            data-testid={BenefitCardTestId.BenefitCard}
            onClick={() => onClick(benefit)}
            id={`benefit-card-${id}`}
        >
            <LogoContainer data-testid={BenefitCardTestId.Image} color={color}>
                <img src={imageUrl} alt="" />
            </LogoContainer>
            <Title>{title}</Title>
            <Provider>{providerName}</Provider>
        </Container>
    );
};
